/**
 * In-shell auth URLs. The website is mounted by apps/shell; Sign In stays on
 * the same origin and opens the Auth MFE at /{locale}/login/ (no separate app URL).
 */

function inferLocale(): string {
  if (typeof window === 'undefined') return 'en';
  const match = window.location.pathname.match(/^\/([a-z]{2})(?:\/|$)/i);
  return match?.[1]?.toLowerCase() ?? 'en';
}

/** Same-origin shell login path. Trailing slash matches shell `trailingSlash: true`. */
export function getShellLoginUrl(locale?: string, redirectTo?: string): string {
  const loc = locale ?? inferLocale();
  const path = `/${loc}/login/`;
  if (!redirectTo) return path;
  const params = new URLSearchParams({ redirect: redirectTo });
  return `${path}?${params.toString()}`;
}
